import alpha from "color-alpha";
const colorMap = (theme) => ({
  aqua: theme.palette.primary[800],
  orange: theme.palette.secondary[800],
  grey: theme.palette.grey[800],
  error: theme.palette.error[900],
  purple: theme.palette.highlight3[700],
  blue: theme.palette.highlight2[700]
});
const borderlessStyles = ({
  theme,
  ownerState
}) => {
  if (ownerState.variant !== "borderless")
    return;
  return {
    ...ownerState.size === "md" && {
      padding: "10px 12px"
    },
    ...ownerState.size === "sm" && {
      padding: "8px 12px"
    },
    ...ownerState.size === "xs" && {
      padding: "6px 12px"
    },
    ...ownerState.size === "xxs" && {
      padding: "4px 8px"
    },
    color: colorMap(theme)[ownerState.color ?? "grey"],
    "&:hover": {
      backgroundColor: alpha(theme.palette.grey[800], 0.08)
    },
    "&:focus-visible": {
      backgroundColor: alpha(theme.palette.grey[900], 0.12),
      boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${alpha(
        theme.palette.grey[900],
        0.12
      )};`
    },
    "&:active": {
      boxShadow: "none"
    },
    "&:disabled": {
      color: alpha(theme.palette.grey[900], 0.38)
    }
  };
};
export {
  borderlessStyles
};
